module.exports = __webpack_public_path__ + "static/media/desP.54cc63b4.jpg";